export default __webpack_public_path__ + "static/media/back.72c90e01.svg";